<template lang="pug">
#eventsSorting.modal.modal-common.animated.fadeInUp1.modal-bottom(tabindex="-1" role="dialog" aria-labelledby="eventsSorting" aria-hidden="true")
  .modal-dialog.modal-dialog-scrollable.m-0(role="document")
    .modal-content
      .modal-header(data-dismiss="modal" aria-label="Close")
        .icon
          i.fas.fa-arrow-left
        h5#exampleModalLabel.modal-title {{ $t("ui.default_event_sorting") }}
      .modal-body.p-0
        ul.list-group.setting(v-for="(item,index) in eventSorting")
          li.list-group-item(:class="{active: defaultEventSorting == index+1}" @click="setDefaultEventSorting(index+1)")
            span {{ $t(item) }}
</template>

<script>
import { EventBus } from "@/library/_event-bus.js";

export default {
  data: () => ({
    eventSorting: ["ui.normal_sorting", "ui.sort_by_time"]
  }),
  computed: {
    defaultEventSorting() {
      return this.$store.getters.pageDisplay.eventSorting;
    }
  },
  methods: {
    setDefaultEventSorting(s) {
      this.$store.dispatch("layout/setSinglePageDisplay", {property: "eventSorting", value: s.toString()});
      EventBus.$emit("DEFAULT_EVENT_SORTING");
      $('#eventsSorting').modal('hide');
    }
  }
}
</script>